<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import ItineraryDayProgramLocationModal from '../../components/itinerary/ItineraryDayProgramLocationModal';
import ItineraryDayProgramList from '../../components/itinerary/ItineraryDayProgramList';
import ItineraryDayProgramHotelModal from '../../components/itinerary/ItineraryDayProgramHotelModal';
import ItineraryDayProgramExcursionModal from '../../components/itinerary/ItineraryDayProgramExcursionModal';
import ItineraryDayProgramMealPlanModal from '../../components/itinerary/ItineraryDayProgramMealPlanModal';
import ItineraryDayProgramImageModal from '../../components/itinerary/ItineraryDayProgramImageModal';

export default {
  name: 'ItineraryEditDayProgram',
  components: {
    ItineraryDayProgramLocationModal,
    ItineraryDayProgramList,
    ItineraryDayProgramHotelModal,
    ItineraryDayProgramExcursionModal,
    ItineraryDayProgramMealPlanModal,
    ItineraryDayProgramImageModal,
  },
  data() {
    return {
      itineraryId: null,
      dayProgramId: null,
      showLocationModal: false,
      showHotelModal: false,
      showExcursionModal: false,
      showMealPlanModal: false,
      showImageModal: false,
    };
  },
  computed: {
    ...mapState({
      dayProgramLoading: state => state.itinerary.dayProgram.loading,
      dayProgramError: state => state.itinerary.dayProgram.error,
      dayProgramItems: state => state.itinerary.dayProgram.items,
      countriesAndAreasItems: state => state.itinerary.masterCountries.items,
      locationDayProgram: state => state.itinerary.dayProgramLocation.dayProgram,
      locationDayProgramSaveLoading: state => state.itinerary.dayProgramLocation.loading,
      hotelDayProgramLoading: state => state.itinerary.dayProgramHotel.loading,
      hotelDayProgram: state => state.itinerary.dayProgramHotel.dayProgram,
      selectedHotels: state => state.itinerary.dayProgramHotel.selectedHotels,
      excursionDayProgramLoading: state => state.itinerary.dayProgramExcursions.loading,
      excursionDayProgram: state => state.itinerary.dayProgramExcursions.dayProgram,
      dayProgramExcursions: state => state.itinerary.dayProgramExcursions.excursions,
      mealPlanTypes: state => state.itinerary.mealPlanTypes.types,
      mealPlanOptions: state => state.itinerary.mealPlanTypes.options,
      mealPlanDayProgram: state => state.itinerary.dayProgramMealPlans.dayProgram,
      dayProgramMealPlans: state => state.itinerary.dayProgramMealPlans.mealPlans,
      mealPlanDayProgramLoading: state => state.itinerary.dayProgramMealPlans.loading,
      selectedDomain: state => state.itinerary.domains.selected,
      dayProgramImagesLoading: state => state.itinerary.dayProgramImages.loading,
      dayProgramImages: state => state.itinerary.dayProgramImages.items,
      itinerary: state => state.itinerary.edit.item,
    }),
    ...mapGetters({
      getAvailableDayProgramHotels: 'itinerary/getAvailableDayProgramHotels',
    }),
  },
  methods: {
    ...mapActions({
      getDayProgram: 'itinerary/getDayProgram',
      getMealPlanTypes: 'itinerary/getMealPlanTypes',
      addDayProgramEntry: 'itinerary/addDayProgramEntry',
      deleteDayProgramEntry: 'itinerary/deleteDayProgramEntry',
      updateDayProgram: 'itinerary/updateDayProgram',
      getCountriesWithAreasByProductTypeId: 'itinerary/getCountriesWithAreasByProductTypeId',
      setLocationDayProgram: 'itinerary/setLocationDayProgram',
      updateDayProgramLocation: 'itinerary/updateDayProgramLocation',
      fetchDayProgramHotelData: 'itinerary/fetchDayProgramHotelData',
      updateDayProgramHotels: 'itinerary/updateDayProgramHotels',
      fetchDayProgramExcursionData: 'itinerary/fetchDayProgramExcursionData',
      updateDayProgramExcursions: 'itinerary/updateDayProgramExcursions',
      getDayProgramMealPlans: 'itinerary/getDayProgramMealPlans',
      updateDayProgramMealPlans: 'itinerary/updateDayProgramMealPlans',
      updateItineraryDomains: 'itinerary/updateItineraryDomains',
      getItineraryDayProgramImages: 'itinerary/getItineraryDayProgramImages',
      uploadItineraryDayProgramImages: 'itinerary/uploadItineraryDayProgramImages',
      updateItineraryDayProgramImages: 'itinerary/updateItineraryDayProgramImages',
      deleteItineraryDayProgramImage: 'itinerary/deleteItineraryDayProgramImage',
    }),
    ...mapMutations({
      setAvailableExcursions: 'itinerary/ITINERARY_DAY_PROGRAM_SET_AVAILABLE_EXCURSIONS',
    }),
    openDayProgramLocationModal(event) {
      this.setLocationDayProgram(event).then(() => {
        this.showLocationModal = true;
      });
    },
    openDayProgramHotelModal(data) {
      this.showHotelModal = true;
      this.fetchDayProgramHotelData({
        itineraryId: this.itineraryId,
        data,
      });
    },
    openDayProgramExcursionModal(data) {
      this.showExcursionModal = true;
      this.fetchDayProgramExcursionData({
        itineraryId: this.itineraryId,
        data,
      });
    },
    openDayProgramMealPlanModal(data) {
      this.showMealPlanModal = true;
      this.getDayProgramMealPlans({
        itineraryId: this.itineraryId,
        data,
      });
    },
    openDayProgramImageModal(data) {
      this.showImageModal = true;
      this.dayProgramId = data.id;
      this.getItineraryDayProgramImages({
        dayProgramId: data.id,
      });
    },
    saveDayProgram(data) {
      const payload = {
        itineraryId: this.itineraryId,
        data,
      };
      this.updateDayProgram(payload);
    },
    saveDayProgramLocation(data) {
      const payload = { itineraryId: this.itineraryId, data };
      const foundDayProgram = this.dayProgramItems.find(dayProgram => dayProgram.id === data.dayProgramId);
      const indexOfDayProgram = this.dayProgramItems.indexOf(foundDayProgram);

      this.updateDayProgramLocation(payload).then(() => {
        this.showLocationModal = false;
      }).catch();

      if (indexOfDayProgram > 0) {
        if (this.dayProgramItems[indexOfDayProgram - 1].areaId === data.areaId
          && this.dayProgramItems[indexOfDayProgram - 1].countryId === data.countryId) {
          const siteIds = this.dayProgramItems[indexOfDayProgram - 1].hotels.map(hotel => hotel.siteId);
          const hotelPayload = { dayProgramId: data.dayProgramId, itineraryId: this.itineraryId, siteIds };
          this.saveDayProgramHotels(hotelPayload);
        }
      }
    },
    saveDayProgramHotels(data) {
      const foundDayProgram = this.dayProgramItems.find(dayProgram => dayProgram.id === data.dayProgramId);
      const payloads = [];
      this.dayProgramItems.forEach((dayProgram) => {
        if (dayProgram.areaId === foundDayProgram.areaId && dayProgram.countryId === foundDayProgram.countryId) {
          if (!dayProgram.hotelCount && dayProgram.id !== foundDayProgram.id) {
            const payload = { dayProgramId: dayProgram.id, itineraryId: this.itineraryId, siteIds: data.siteIds };
            payloads.push(payload);
          }
        }
      });

      payloads.forEach((payload) => {
        this.updateDayProgramHotels(payload).then(() => {
          this.showHotelModal = false;
        }).catch();
      });

      this.updateDayProgramHotels(data).then(() => {
        this.showHotelModal = false;
      }).catch();
    },
    saveDayProgramExcursions(data) {
      this.updateDayProgramExcursions(data).then(() => {
        this.showExcursionModal = false;
      }).catch();
    },
    saveDayProgramMealPlans(data) {
      this.updateDayProgramMealPlans(data).then(() => {
        this.showMealPlanModal = false;
      }).catch();
    },
    updateItineraryDomain(event) {
      this.updateItineraryDomains({
        itineraryId: this.$route.params.id,
        itineraryDomains: [event],
      });
    },
  },
  created() {
    this.itineraryId = parseInt(this.$route.params.id, 10);
    this.getDayProgram(this.itineraryId);
    this.getCountriesWithAreasByProductTypeId(this.itinerary.productTypeId);
    this.getMealPlanTypes();
  },
};
</script>

<template>
  <div>
    <itinerary-day-program-list
      :itinerary-id="itineraryId"
      :day-program-loading="dayProgramLoading"
      :day-program-error="dayProgramError"
      :day-program-items="dayProgramItems"
      :selected-domain="selectedDomain"
      @addDayProgramEntry="addDayProgramEntry"
      @deleteDayProgramEntry="deleteDayProgramEntry"
      @saveDayProgram="saveDayProgram"
      @openLocationModal="openDayProgramLocationModal"
      @openHotelModal="openDayProgramHotelModal"
      @openExcursionModal="openDayProgramExcursionModal"
      @openMealPlanModal="openDayProgramMealPlanModal"
      @openImageModal="openDayProgramImageModal"
      @updateDomain="updateItineraryDomain"
    />
    <itinerary-day-program-location-modal
      v-if="showLocationModal && locationDayProgram"
      :countries-and-areas="countriesAndAreasItems"
      :day-program="locationDayProgram"
      :day-program-save-loading="locationDayProgramSaveLoading"
      @cancel="showLocationModal = false"
      @saveDayProgramLocation="saveDayProgramLocation"
    />
    <itinerary-day-program-hotel-modal
      v-if="showHotelModal"
      :itinerary-id="itineraryId"
      :loading="hotelDayProgramLoading"
      :day-program="hotelDayProgram"
      :available-hotels="getAvailableDayProgramHotels"
      :selected-hotels="selectedHotels"
      @cancel="showHotelModal = false"
      @update="saveDayProgramHotels"
    />
    <itinerary-day-program-excursion-modal
      v-if="showExcursionModal"
      :loading="excursionDayProgramLoading"
      :day-program="excursionDayProgram"
      :available-extras="dayProgramExcursions"
      :countries-and-areas="countriesAndAreasItems"
      :itinerary-id="itineraryId"
      @update="saveDayProgramExcursions"
      @cancel="showExcursionModal = false"
    />
    <itinerary-day-program-image-modal
      v-if="showImageModal"
      :loading="dayProgramImagesLoading"
      :images="dayProgramImages"
      :day-program-id="dayProgramId"
      @upload="uploadItineraryDayProgramImages"
      @update="updateItineraryDayProgramImages"
      @close="showImageModal = false"
      @remove="deleteItineraryDayProgramImage"
    />
    <itinerary-day-program-meal-plan-modal
      v-if="showMealPlanModal"
      :itinerary-id="itineraryId"
      :loading="mealPlanDayProgramLoading"
      :day-program="mealPlanDayProgram"
      :meal-plan-mappings="dayProgramMealPlans"
      :meal-plan-types="mealPlanTypes"
      :meal-plan-options="mealPlanOptions"
      @update="saveDayProgramMealPlans"
      @cancel="showMealPlanModal = false"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryEditDayProgram.vue